import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronUp } from "lucide-react";
import "@/App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustedOps from "./components/TrustedOps";
import ProductStory from "./components/ProductStory";
import Features from "./components/Features";
import Roles from "./components/Roles";
import Timeline from "./components/Timeline";
import Security from "./components/Security";
import Showcase from "./components/Showcase";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import Partners from "./components/Partners";
import Trust from "./components/Trust";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Terms from "./components/Terms";
import Imprint from "./components/Imprint";
import DPA from "./components/DPA";
import CookieConsent from "./components/CookieConsent";

function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.6 }}
          whileTap={{ scale: 0.92 }}
          transition={{ type: "spring", stiffness: 380, damping: 26 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Scroll to top"
          className="fixed bottom-8 right-8 z-50 w-12 h-12 rounded-full bg-[#FF4F00] hover:bg-[#CC3800] grid place-items-center shadow-[0_0_24px_rgba(255,79,0,0.45)] hover:shadow-[0_0_32px_rgba(255,79,0,0.65)] transition-all duration-300"
        >
          <ChevronUp className="w-5 h-5 text-white" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}

function LandingPage() {
  return (
    <div className="App relative" data-testid="landing-root">
      <div className="pointer-events-none" aria-hidden="true">
        <div className="bg-orb bg-orb-1" />
        <div className="bg-orb bg-orb-2" />
        <div className="bg-orb bg-orb-3" />
        <div className="lightning-flash" />
      </div>
      <Navbar />
      <main>
        <Hero />
        <TrustedOps />
        <ProductStory />
        <Features />
        <Roles />
        <Timeline />
        <Security />
        <Showcase />
        <FinalCTA />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

function App() {
  useEffect(() => {
    const loader = document.getElementById('page-loader');
    if (loader) {
      loader.style.opacity = '0';
      setTimeout(() => loader.remove(), 500);
    }
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/trust" element={<Trust />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/dpa" element={<DPA />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
